import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { FinancialConnection } from '@40seas/entities/financial-connections';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { FinancialConnectionRefreshRequestStatus } from './financial-connection-refresh-request.status.enum';
import { FinancialConnectionRefreshRequestType } from './financial-connection-refresh-request.type.enum';

const FinancialConnectionRefreshRequestSchema = WithBaseEntitySchema(
    z
        .object({
            buyerId: z.string(),
            financialConnection: z.string().or(FinancialConnection['schema']),
            type: EnumSchema(FinancialConnectionRefreshRequestType),
            status: EnumSchema(FinancialConnectionRefreshRequestStatus),
            data: z.string().or(z.number()).optional(),
            failureCode: z.string().optional(),
            failureMessage: z.string().optional(),
        })
        .strict(),
);

export class FinancialConnectionRefreshRequest extends FromSchema(FinancialConnectionRefreshRequestSchema) implements BaseEntity {
    id: string;
    buyerId: string;
    financialConnection: string | FinancialConnection;
    type: FinancialConnectionRefreshRequestType;
    status: FinancialConnectionRefreshRequestStatus;
    data?: string | number;
    failureCode?: string;
    failureMessage?: string;
    updatedAt: Date;
    createdAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
